import React, { useMemo } from 'react';
import styles from './index.module.scss';
import { Popover } from '@mantine/core';
import { Text } from '@shakkerai/pro-components';
import { createPortal } from 'react-dom';
import { getGuidanceConfig } from '../../config/index';
import { useGuidanceRestartHooks } from '../../hooks';
import { mc } from '@shakkerai/report';
import { translate } from '@shakkerai/util-i18n';

export const GuidePopover = (props) => {
  const {
    index = 'Enter',
    visible,
    position = 'right',
    offset = { mainAxis: 20, crossAxis: -18 },
    arrowOffset = 50,
    targetClassName,
    showIndex = true,
    withinPortal = true,
    title,
    content,
    showSkip = true,
  } = props;

  const guidanceConfig = useMemo(() => {
    return getGuidanceConfig(index);
  }, [index]);

  const { skipGuidance } = useGuidanceRestartHooks();

  // const showBottom = position === 'bottom';

  // 控制是否显示，显示位置，显示内容
  return (
    <div>
      <Popover
        width={250}
        offset={offset}
        position={position}
        radius={8}
        withArrow
        shadow="md"
        opened={visible}
        arrowOffset={arrowOffset}
        arrowSize={15}
        arrowRadius={4}
        zIndex={71}
        withinPortal={withinPortal}
      >
        <Popover.Target>
          <div className={`h-[1px] ${targetClassName}`}></div>
        </Popover.Target>

        <Popover.Dropdown className={styles.guidancePopover}>
          <div className="">
            {/* {!showBottom && <div className="w-full h-[2px] bg-primary"></div>} */}

            <div className="p-[10px]">
              <Text fw={700} color="#222">
                {title || guidanceConfig.title}
              </Text>
              <Text className="mt-1" color="#222" fw={500}>
                {content || guidanceConfig.content}
              </Text>

              {(showSkip || showIndex) && (
                <div className="mt-4 flex justify-between items-center">
                  {showSkip && (
                    <Text
                      className={` ${styles.skip}`}
                      fw={600}
                      onClick={() => {
                        skipGuidance();
                        mc('landing_skip');
                      }}
                    >
                      {translate('common_skip')}
                    </Text>
                  )}

                  {showIndex && (
                    <Text className="" color="#222" fw={600}>
                      {guidanceConfig.indexStr}
                    </Text>
                  )}
                </div>
              )}
            </div>

            {/* {showBottom && <div className="w-full h-[2px] bg-primary"></div>} */}
          </div>
        </Popover.Dropdown>
      </Popover>
    </div>
  );
};

export const GuidanceMask = (props) => {
  const { visible } = props;

  // const { skipGuidance } = useGuidanceRestartHooks();

  // eslint-disable-next-line
  // const onSkip = useCallback(skipGuidance);

  if (visible) {
    return createPortal(
      <div className={`${styles.mask} bg-black/[0.35]`}>
        {/* <div className={styles.skip} onClick={onSkip}>
          Skip Guidance
        </div> */}
      </div>,
      document.body,
    );
  } else {
    return null;
  }
};

/**
 * 输入控制遮罩
 * @returns
 */
export const InputMask = (props) => {
  const { visible, className } = props;

  if (visible) {
    return <div className={`bg-black/[0.35] absolute top-0 left-0 right-0 bottom-0 ${className}`}></div>;
  } else {
    return null;
  }
};
